import ProjectViews from "../project-views"

// gd.projectViews may be unset or hold a different project (info opens over a background app),
// so fall back to a detached snapshot - beware its save() overwrites concurrent view changes
export default function projectViews_getByProjectId(projectId: ID):ProjectViews {
    return gd.projectViews?.project.id === projectId ? gd.projectViews : ProjectViews.initByProjectId(projectId)
}
